<template>
<div id="personalMsg">
  <Modal v-model="modal.visible" :title="modal.title" footer-hide>
    <IForm :key="modal.visible" ref="personalMsg" label-position="top" :elem="personalMsgElem" :model="personalMsg" :rules="personalMsgRule" :btn-loading="loading" :width="320" @on-submit="handleSubmit" @on-click="modal.visible = false" submit-text="保存" button button-text="取消" />
    <!-- IForm -->
  </Modal>
</div>
</template>
<script>
import { _editPersonalMsg } from "@/services/app";
import { _getUserById } from "@/services/manage/users";
import { mapGetters } from "vuex";
export default {
  name: "personalMsg",
  data() {
    return {
      // 加载状态
      loading: false,
      // 模态框属性
      modal: {
        title: "",
        visible: false
      },
      // 表单元素数组
      personalMsgElem: [
        {
          label: "账号",
          prop: "name",
          disabled: true,
          placeholder: "请输入您原来的密码",
        },
        {
          label: "真实姓名",
          prop: "realName",
          placeholder: "请输入您的真实姓名",
        },
        {
          label: "电话号码",
          prop: "phone",
          placeholder: "请输入您的电话号码",
        }
      ],
      // 表单数据对象
      personalMsg: {
        realName: "",
        phone : "",
        username: ""
      },
      // 表单验证规则
      personalMsgRule: {
        realName: [
          {
            required: true,
            message: "请输入你的真实姓名",
            trigger: "blur"
          }
        ],
        phone : [
          {
            required: true,
            message: "请输入你的电话号码",
            trigger: "blur"
          }
        ],
      }
    };
  },
  computed:{
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  },
  methods: {
    showModal() {
      _getUserById({id: this.userInfo.userId}).then(res =>{
        if (res.errcode === 1 && res.data){
          this.modal = {
            title: "个人资讯详情",
            visible: true
          };
          this.personalMsg = {
            userId: res.data.id,
            name: res.data.name,
            realName : res.data.realName ,
            phone: res.data.phone,
          };
        } else {
          this.$message.error("获取用户信息失败!")
        }
      })
    },
    handleSubmit() {
      this.$Loading.start();
      this.loading = true;
      setTimeout(() => {
        _editPersonalMsg(this.personalMsg)
          .then(res => {
            this.$Message.success(res.errmsg);
            this.$Loading.finish();
            this.loading = false;
            this.modal.visible = false;
          })
          .catch(() => {
            this.$Loading.error();
            this.loading = false;
          });
      }, 500);
    }
  }
};
</script>
